import { render, staticRenderFns } from "./sideSubmenu.vue?vue&type=template&id=8a985886&scoped=true&"
import script from "./sideSubmenu.vue?vue&type=script&lang=js&"
export * from "./sideSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./sideSubmenu.vue?vue&type=style&index=0&id=8a985886&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a985886",
  null
  
)

export default component.exports